import { Ingreso } from './ingreso';
import { Mercaderia } from './mercaderia';
import { Usuario } from './usuario';

export class DetalleIngreso {
  id: number;
  ingreso: Ingreso;
  mercaderia: Mercaderia;
  usuario: Usuario;
  precio: number;
  precio2: number;
  cantidad: number;
  constructor() {
    this.ingreso = new Ingreso();
    this.mercaderia = new Mercaderia();
    this.usuario = new Usuario();
  }

}